module.exports = __webpack_public_path__ + "static/wkyCash.941b4a2f.png";